import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 8h4","key":"svg-0"}],["path",{"d":"M5 8v8","key":"svg-1"}],["path",{"d":"M17 8h4","key":"svg-2"}],["path",{"d":"M19 8v8","key":"svg-3"}],["path",{"d":"M10 8l4 8","key":"svg-4"}],["path",{"d":"M10 16l4 -8","key":"svg-5"}]]

const IconTxt = createReactComponent('outline', 'txt', 'Txt', __iconNode);

export default IconTxt;